import { Box } from "@mui/material";

import EpisodeCard from "./episodeCard";

import { IContentListResponse, IContentShowResponse } from "@/api/types/content";

interface IShowEpisodes {
    data: IContentShowResponse[];
    // eslint-disable-next-line no-unused-vars
    onEdit: (id: IContentListResponse) => void;
    // eslint-disable-next-line no-unused-vars
    onDelete: (id: number) => void;
}

export default function ShowEpisodes({ data, onEdit, onDelete }: IShowEpisodes) {
    return (
        <Box className="show-episode-list">
            {data.map((episode) => {
                return <EpisodeCard key={episode.id} data={episode} onDelete={onDelete} onEdit={onEdit} />;
            })}
        </Box>
    );
}
